import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  scrollTo: {
    "& li > div > div > p": {
      minWidth: 130,
      textAlign: "center",
    },
  },
  scrollToRoot: {
    padding: `0 0 ${theme.hv.spacing.sm}px 0`,
  },
  scrollToSticky: {
    top: 72,
  },
  title: {
    ...theme.hv.typography.xsTitle,
  },
  zIndex: {
    zIndex: 200,
  },
}));

export default useStyles;
